const initialState = {
    registerResponse: null,
    resendResponse: null,
    confirmationResponse: null,
    confirmationError: null,
    error: null,
    loading: false,
};

export default function registerReducer(state = initialState, action) {
    switch (action.type) {
        case 'REGISTER_REQUEST': 
            return {
                ...state,
                loading: true, 
                error: null,   
            };
        case 'REGISTER_SUCCESS': 
            return {
                ...state,
                registerResponse: action.payload, // Save success response
                loading: false, // Set loading to false
                error: null,    // Clear any errors
            };
        case 'REGISTER_FAILURE': // Triggered on failed response
            return {
                ...state,
                error: action.payload, // Save error message
                loading: false,        // Set loading to false
            };
        case 'RESET_REGISTER_RESPONSE':
            return {
                ...state,
                registerResponse: null,
                loading: false,
            }
        case 'RESEND_SUCCESS':
            return {
                ...state,
                resendResponse: action.payload,
                error: null,
            };
        case "CONFIRMATION_REQUEST":
            return {
                ...state,
                loading: true,
                confirmationError: null,
            };
        case "CONFIRMATION_SUCCESS":
            return {
                ...state,
                confirmationResponse: action.payload,
                loading: false,
                confirmationError: null,
            };
        case "CONFIRMATION_FAILURE":
            return {
                ...state,
                confirmationError: action.payload,
                loading: false,
            };
        default:
            return state; // Return current state for unhandled actions
    }
}
